import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const CircleComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { centerX, centerY, radius, fill = "lightgreen", stroke = "green", strokeWidth = 2 } = params;
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <circle
        cx={centerX}
        cy={centerY}
        r={radius}
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      
      {showCoords && (
        <DraggablePoint 
          cx={centerX} cy={centerY} 
          label="Center" coords={`(${centerX},${centerY})`}
          onDrag={(x, y) => onPointDrag('centerX', x, 'centerY', y)}
          svgRef={svgRef}
        />
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

